/* eslint-disable */
import type { CashInstrumentType } from "../cash_instrument_type.pb";

export enum CardStatus {
  VALID = "VALID",
  NOT_LINKED = "NOT_LINKED",
  INVALID = "INVALID",
  EXPIRED = "EXPIRED",
  UNSUPPORTED_FOR_ROLE = "UNSUPPORTED_FOR_ROLE",
  /** UNSUPPORTED_FOR_DEPOSIT_PREFERENCE - Added for v2.12. */
  UNSUPPORTED_FOR_DEPOSIT_PREFERENCE = "UNSUPPORTED_FOR_DEPOSIT_PREFERENCE",
}

export interface CardBlocker {
  card_status?: CardStatus;
  /**
   * A list of supported instrument types that can unblock this payment. At present, this list
   * will always include DEBIT_CARD. For businesses receiving this blocker for a payment or for
   * onboarding, the list will also include BANK_ACCOUNT.
   */
  supported_instrument_types?: CashInstrumentType[];
}
